import { Component, Inject, OnInit, Input } from "@angular/core";
import { Calculation, Client } from "@salaxy/core";
import { ClientNg, SalaxyContext } from "../../../services/index";

/**
 * Simple calculator user interface.
 * This is the anonymous version
 */
@Component({
    providers: [ClientNg],
    selector: "salaxy-calculator",
    template: `<div class="salaxy-component salaxy-calculator">
    <div *ngIf="model">
        <table cellspacing=50>
            <tr>
                <th width="45%">Input</th>
                <th></th>
                <th width="45%">Result</th>
            </tr>
            <tr>
                <td>
                    <table>
                        <tr>
                            <td>
                                <mat-input-container><input mdInput placeholder="Amount in euro" type="number" [(ngModel)]="model.salary.price" name="price"></mat-input-container>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <mat-input-container><input mdInput placeholder="Number of hours, months etc." type="number" [(ngModel)]="model.salary.amount" name="amount"></mat-input-container>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <mat-select placeholder="Salary type" [(ngModel)]="model.salary.kind" name="kind" style="width:100%">
                                    <mat-option value="fixedSalary">fixedSalary</mat-option>
                                    <mat-option value="undefined">undefined</mat-option>
                                    <mat-option value="hourlySalary">hourlySalary</mat-option>
                                    <mat-option value="monthlySalary">monthlySalary</mat-option>
                                    <mat-option value="totalWorkerPayment">totalWorkerPayment</mat-option>
                                    <mat-option value="totalEmployerPayment">totalEmployerPayment</mat-option>
                                </mat-select>
                            </td>
                        </tr>
                    </table>
                </td>
                <td>
                    <button md-raised-button color="primary" (click)="recalculate()">Laske</button>
                </td>
                <td>
                    <div *ngIf="!model.result">
                        <p>Click "Calculate" to see results here.</p>
                    </div>
                    <div *ngIf="model.result">
                        <table>
                            <tr>
                                <td>Total gross:</td>
                                <td>{{ model.result.totals.totalGrossSalary | currency }}</td>
                            </tr>
                            <tr>
                                <td>Total net salary:</td>
                                <td>{{ model.result.workerCalc.salaryPayment | currency }}</td>
                            </tr>
                            <tr>
                                <td>Total payment:</td>
                                <td>{{ model.result.employerCalc.totalSalaryCost | currency }}</td>
                            </tr>
                        </table>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</div>
`,
})
export class NgCalculatorComponent implements OnInit {

    /** Internal field for model */
    private modelState: Calculation;

    /** The calculation that we operate */
    @Input()
    public get model(): Calculation {
        return this.modelState;
    }
    public set model(value: Calculation) {
        this.modelState = value;
    }

    constructor(
        protected context: SalaxyContext,
        @Inject(ClientNg) protected client: Client,
    ) {
    }

    /** Initializes the component */
    public ngOnInit() {
        this.modelState = this.context.calculations.getBlank();
    }

    /** Recalculates the calculation */
    public recalculate() {
        this.client.calculatorApi.recalculate(this.model).then((calc) => {
            this.modelState = calc;
        });
    }
}
